// removed by extract-text-webpack-plugin
module.exports = {"pageRoot":"styles__pageRoot__3R7QZ","loadingText":"styles__loadingText__jvaFA","errorText":"styles__errorText__IG6cT","centerLoader":"styles__centerLoader__3NlVz","centerBlock":"styles__centerBlock__2RcN5","contentContainer":"styles__contentContainer__3w0_7","cover":"styles__cover__2Rw7I","padding":"styles__padding__3VScf","markdownDescription":"styles__markdownDescription__TKchT","markdown":"styles__markdown__3CI4n","summaryMarkdown":"styles__summaryMarkdown__2YhgH","buttonPrimary":"styles__buttonPrimary__389AV","blueBackground":"styles__blueBackground__1W4FL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BlogContent/styles.css
// module id = 1499
// module chunks = 0